import { postBatchRedtailQueries } from '../../../../../api/redtail'
import { postNamedQuery } from '../../../../../service'

export async function fetchActivities (members, clientId, dateParams) {
  const queries = members
    ? members.map(member => ({
      query: 'listActivities',
      request: {
        params: {
          contact_id: member.contact_id ?? member.id,
          ...dateParams
        }
      }
    }))
    : [{
      query: 'listActivities',
      request: { params: dateParams }
    }]

  const { results } = await postBatchRedtailQueries(queries, { clientId })

  return results
    .filter(r => r.status === 'fulfilled')
    .flatMap(r => r.data?.activities ?? [])
}

export async function fetchWorkflows (members, clientId, params = {}) {
  const queries = members
    ? members.map(member => ({
      query: 'listWorkflows',
      request: {
        params: {
          contact_id: member.contact_id ?? member.id,
          ...params
        }
      }
    }))
    : [{
      query: 'listWorkflows',
      request: { params }
    }]

  const { results } = await postBatchRedtailQueries(queries, { clientId })

  return results
    .filter(r => r.status === 'fulfilled')
    .flatMap(r => r.data?.workflows ?? [])
}

export async function fetchSingleWorkflow (workflowId, clientId) {
  const { data } = await postNamedQuery('coreData', 'execute-redtail-domain-query', {
    query: 'getWorkflow',
    autoResolveConnection: true,
    clientId,
    request: { workflowId }
  })
  return data?.workflow ?? data
}

export function deduplicateById (items) {
  const seen = new Set()
  return items.filter(item => {
    if (seen.has(item.id)) return false
    seen.add(item.id)
    return true
  })
}

export async function fetchContactNotes (members, clientId) {
  if (!members?.length) return []

  const queries = members.map(member => ({
    query: 'listContactNotes',
    request: {
      contactId: member.contact_id ?? member.id
    }
  }))

  const { results } = await postBatchRedtailQueries(queries, { clientId })

  const tagged = results
    .flatMap((r, i) => {
      if (r.status !== 'fulfilled') return []
      const member = members[i]
      const name = member?.full_name ||
        `${member?.first_name ?? ''} ${member?.last_name ?? ''}`.trim() ||
        null
      return (r.data?.notes ?? []).map(note => ({ ...note, _contact_name: name }))
    })

  return deduplicateById(tagged)
}

export async function fetchCategories (clientId) {
  const { data } = await postNamedQuery('coreData', 'execute-redtail-domain-query', {
    query: 'listCategories',
    autoResolveConnection: true,
    clientId,
    request: {}
  })
  return (data?.categories ?? []).map(c => ({
    label: c.name,
    value: c.id
  }))
}
